export default function HelloWorld() {
    return (
        <>
            <div className='container-fluid' style={{marginTop:"5px"}}>
                <h1 className='fw-bold' style={{fontFamily: "emoji"}}>Hello World</h1>
            </div>
        </>
    )
}